module.exports = __webpack_public_path__ + "img/edi-3.85ec49ad.png";